// Track condition utility functions for styling and display
export interface TrackConditionStyle {
  color: string;
  bgColor: string;
  textColor: string;
  icon: string;
}

// Map track conditions to their display styling
export const getTrackConditionStyle = (trackCondition: string): TrackConditionStyle => {
  const condition = trackCondition?.toLowerCase() || '';
  
  switch (condition) {
    case 'good':
      return {
        color: 'green',
        bgColor: 'bg-green-600',
        textColor: 'text-white',
        icon: '☀️'
      };
    case 'soft':
      return {
        color: 'blue',
        bgColor: 'bg-blue-600',
        textColor: 'text-white',
        icon: '☁️'
      };
    case 'heavy':
      return {
        color: 'orange',
        bgColor: 'bg-orange-600',
        textColor: 'text-white',
        icon: '🌧️'
      };
    case 'firm':
      return {
        color: 'purple',
        bgColor: 'bg-purple-600',
        textColor: 'text-white',
        icon: '🏜️'
      };
    case 'dead':
      return {
        color: 'gray',
        bgColor: 'bg-gray-600',
        textColor: 'text-white',
        icon: '🌫️'
      };
    case 'slow':
      return {
        color: 'yellow',
        bgColor: 'bg-yellow-600',
        textColor: 'text-white',
        icon: '⏳'
      };
    case 'fast':
      return {
        color: 'emerald',
        bgColor: 'bg-emerald-600',
        textColor: 'text-white',
        icon: '⚡'
      };
    case 'synthetic':
      return {
        color: 'amber',
        bgColor: 'bg-amber-700',
        textColor: 'text-white',
        icon: '🟫'
      };
    default:
      return {
        color: 'amber',
        bgColor: 'bg-amber-700',
        textColor: 'text-white',
        icon: '🟫'
      };
  }
};

// Format track condition for display (capitalize first letter)
export const formatTrackCondition = (trackCondition: string): string => {
  if (!trackCondition) return '';
  return trackCondition.charAt(0).toUpperCase() + trackCondition.slice(1).toLowerCase();
};

// Check if track condition should be displayed
export const shouldShowTrackCondition = (trackConditions: any): boolean => {
  return trackConditions && 
         trackConditions.trackCondition && 
         trackConditions.trackCondition.trim() !== '' &&
         !trackConditions.abandoned;
};